import { Box } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import GeneralDetailsStep from 'components/WizardViews/SalaryComponents/CreateNonPayableBenefits/GeneralDetailsStep';
import { ReviewStep } from 'components/WizardViews/SalaryComponents/CreateNonPayableBenefits/ReviewStep';
import {
  createNonPayableBenefitsRouteToStepMap,
  nonPayableBenefitsSteps,
} from 'components/WizardViews/SalaryComponents/constants';
import { WizardHeader, WizardProgressView, WizardWrapper } from 'components/WizardViews/components';
import WizardPathToStepController from 'components/WizardViews/components/WizardPathToStepController';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { FormProvider } from 'forms';
import { Wizard, WizardStep } from 'forms/Wizard';
import React from 'react';
import { useHistory } from 'react-router-dom';

const CreateNonPayableBenefitsForm = () => {
  const history = useHistory();

  const handleCloseClick = () => {
    history.push(routePaths.salaryComponents.nonPayableBenefitsListView);
  };

  return (
    <WizardInfoProvider initialStep={0} totalSteps={2}>
      <FormProvider>
        <WizardPathToStepController routeStepMap={createNonPayableBenefitsRouteToStepMap} />
        <WizardWrapper>
          <WizardHeader
            heading="New"
            subHeading="Non-Payable Benefits component"
            onCloseClick={handleCloseClick}>
            <WizardProgressView
              steps={[
                { label: 'General', position: nonPayableBenefitsSteps.step1 },
                { label: 'Review', position: nonPayableBenefitsSteps.step2 },
              ]}
            />
          </WizardHeader>
          <Box flex={1} overflowY="auto" height="100%">
            <Wizard>
              <WizardStep step={nonPayableBenefitsSteps.step1} component={GeneralDetailsStep} />
              <WizardStep step={nonPayableBenefitsSteps.step2} component={ReviewStep} />
            </Wizard>
          </Box>
        </WizardWrapper>
      </FormProvider>
    </WizardInfoProvider>
  );
};

export default CreateNonPayableBenefitsForm;
